var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00814 52.2985C8.70917 50.9665 9.54611 49.6444 10.8775 49.3455L90.4313 31.4902C91.7625 31.1915 93.0844 32.029 93.3834 33.3611L103.452 78.2234C104.349 82.2195 101.838 86.186 97.8443 87.0824L27.9334 102.773C23.9391 103.67 19.9741 101.157 19.0772 97.1608L9.00814 52.2985Z",
    fill: "#8A9FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8585 78.1832C97.1575 79.5155 96.3203 80.8374 94.9891 81.1362L27.4889 96.2861C26.1575 96.585 24.8359 95.7476 24.5368 94.4152L19.1234 70.2957C18.8244 68.9639 19.6613 67.6416 20.9928 67.3427L88.493 52.1928C89.8241 51.894 91.1461 52.7318 91.445 54.0637L96.8585 78.1832Z",
    fill: "#5775FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9467 3.15997C76.5727 1.25973 81.0525 2.66041 82.9526 6.28848L85.2462 10.668C85.8797 11.8773 85.4133 13.3711 84.2048 14.0045L21.864 46.6748L90.2316 31.3303C91.5628 31.0315 92.8847 31.869 93.1836 33.2012L94.2663 38.0251C95.1633 42.0213 92.6523 45.9876 88.6582 46.8841L18.7472 62.5751C14.7531 63.4716 10.788 60.9587 9.89108 56.9624L8.40513 50.3418L6.3562 46.4297C4.45606 42.8017 5.85511 38.3201 9.48106 36.4199L72.9467 3.15997Z",
    fill: "#5775FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8022 22.6371L80.9327 15.7558L60.921 9.49881L47.7902 16.3802L67.8022 22.6371ZM61.2368 26.0778L48.1058 32.9592L28.094 26.7022L41.2248 19.8208L61.2368 26.0778ZM41.5404 36.3998L28.4096 43.2812L8.39781 37.0242L21.5286 30.1428L41.5404 36.3998ZM42.9412 41.9446L28.4769 45.191L17.2607 62.909L31.725 59.6626L42.9412 41.9446ZM50.1734 40.3213L64.6379 37.0749L53.4215 54.793L38.9571 58.0394L50.1734 40.3213ZM86.3343 32.2053L71.87 35.4517L60.6538 53.1698L75.1181 49.9234L86.3343 32.2053Z",
    fill: "#BDC9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapper);
export default __webpack_public_path__ + "static/media/clapper.41d0bc3e65716b4575a5782fa1a88ccd.svg";
export { ForwardRef as ReactComponent };